// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  BundleMemberInput,
  BundleResponse,
  bundleResponseSchema,
} from '@/bundle/api/types';

/**
 * Parameters for creating a bundle.
 */
interface CreateBundleParameters {
  name: string;
  description?: string | null;
  members: BundleMemberInput[];
}

/**
 * Creates a bundle in the catalog.
 * Returns the created bundle including its members.
 */
export async function createBundle(
  parameters: CreateBundleParameters
): Promise<BundleResponse> {
  const url = '/v1/catalog/bundle';
  const response = await api.post(url, parameters);
  return parseResponse(bundleResponseSchema, response.data, {
    schemaName: 'CreateBundle',
    endpoint: url,
  });
}
